import React from 'react'

import { useAPIGetIndikatorKompetensiOptions } from 'api/kinerja/penilik-pegawai/perencanaan'

import type { PengembanganKompetensiIndikatorOptions } from 'types/kinerja-penilik-pegawai'

const FALLBACK_INDICATOR_DATA = {
  none: [],
}

type TIndikatorKompetensiHooks = {
  isReferensiKompetensi: boolean
  indikatorKompetensiData: Partial<PengembanganKompetensiIndikatorOptions>
}
export const useIndikatorKompetensi = (): TIndikatorKompetensiHooks => {
  const {
    data: indikatorKompetensiResponse,
    isSuccess: isIndikatorKompetensiSuccess,
  } = useAPIGetIndikatorKompetensiOptions()

  const indikatorKompetensiData = React.useMemo(() => {
    if (isIndikatorKompetensiSuccess) {
      return indikatorKompetensiResponse ?? FALLBACK_INDICATOR_DATA
    }

    return FALLBACK_INDICATOR_DATA
  }, [isIndikatorKompetensiSuccess, indikatorKompetensiResponse])

  const isReferensiKompetensi = React.useMemo(() => {
    return Object.keys(indikatorKompetensiData).some(
      (key) => key !== 'none' && indikatorKompetensiData[key].length > 0
    )
  }, [indikatorKompetensiData])

  return {
    isReferensiKompetensi,
    indikatorKompetensiData,
  }
}
